var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._l(_vm.breadcrumbs, function (breadcrumb) {
    return _c('b-breadcrumb-item', {
      key: breadcrumb.name,
      attrs: {
        "to": breadcrumb.to,
        "active": breadcrumb.clickable === false
      }
    }, [_vm._v(_vm._s(breadcrumb.name))]);
  }), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("查看角色")])], 2)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.organizationName) + "查看角色 ")]), _c('role-form', {
    ref: "form",
    attrs: {
      "role": _vm.role,
      "is-read-only": true
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, _vm._l(_vm.groupedPermissions, function (permissions, key) {
    return _c('div', {
      key: key,
      staticClass: "row"
    }, [_c('p', {
      staticClass: "col-lg-2 col-12 px-0"
    }, [_vm._v(_vm._s(key))]), _c('div', {
      staticClass: "col-lg-10 col-12 d-flex flex-wrap mb-3"
    }, _vm._l(permissions, function (permission) {
      return _c('b-form-checkbox', {
        key: permission.key,
        attrs: {
          "value": permission.id,
          "disabled": ""
        },
        model: {
          value: _vm.checkedPermissions,
          callback: function callback($$v) {
            _vm.checkedPermissions = $$v;
          },
          expression: "checkedPermissions"
        }
      }, [_vm._v(" " + _vm._s(permission.name) + " ")]);
    }), 1)]);
  }), 0)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "to": _vm.getRoleListLink(),
      "variant": "outline-danger"
    }
  }, [_vm._v("返回 ")])], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }